export enum SubscriptionSelection {
	Cafeina = "Cafeina",
	MothersBlend = "MothersBlend",
	FathersChoice = "FathersChoice",
}
